<template lang="pug">
.Youtube
  Loader.Youtube__loader(v-if="loading")
  .Youtube__content(v-else)
    RssList.Youtube__content__list(
      v-if="!selected && !params.auto"
      :list="list"
      @select="select")
    YoutubePlayer.Youtube__content__player(
      v-else
      :videoIdList="videoIdList")
</template>

<script>
import YoutubePlayer from '@/components/page-components/YoutubePlayer.vue';
import Loader from '@/components/page-components/Loader.vue';
import RssList from '@/components/page-components/RssList.vue';
import MMS from 'webmms-client';

export default {
  name: 'Youtube',
  props: ['pageParams'],
  components: {
    YoutubePlayer,
    Loader,
    RssList,
  },
  data() {
    return {
      selected: false,
      current: 0,
      mms: null,
      response: null,
      state: '',
      loading: true,
      params: {},
      eiInfo: {
        eiName: 'yp',
        eiTag: '',
        ddn : ''
      },
        webmmsOptions : {
          EiToken: '',
          SToken: '',
          UToken: ''
      },
      error: false,
      errorMsg: '',
      timeout: 3000,
      mmsReady: false,
      config: {
        app: '',
        websockURL: 'https://ws1.ypcloud.com',
        topic: 'svc://blog-mms',
        invokeFn: 'getPosts',
        params: {
          tags: {
            default: 'ypcloud',
            reducer(v) {
              return v.split(',').map(o => `#${o}`);
            },
          },
          auto: {
            default: '0',
            reducer(v) {
              let r;
              if (v === '0') r = false;
              if (v === '1') r = true;
              return r;
            },
          },
        },
      },
    };
  },
  computed: {
    list() {
      return !this.response
        ? null
        : this.response[0].Reply.reduce((acc, o) => {
          const l = acc;
          const videoId = this.getVideoId(o.content.rendered);
          if (videoId) {
            const c = {
              title: o.title.rendered,
              videoId,
            };

            l.push(c);
          }
          return l;
        }, []);
    },
    videoIdList() {
      return this.params.auto
        ? this.list.map(o => o.videoId)
        : this.list[this.current].videoId;
    },
  },
  created() {
    try {
      this.setParams();
      this.startMMS('', this.config.websockURL);
    } catch (e) {
      this.state = e.message;
    }
  },
  async beforeMount() {
       await this.subscribeMMS();
    },
  methods: {
    select(index) {
      this.current = index;
      this.selected = true;
    },
    getVideoId(str) {
      const reg = /www.youtube.com\/embed\/(.*)\?/;
      const res = reg.exec(str);
      return res ? res[1] : null;
    },
    setParams() {
      //const urlps = new URL(window.location).searchParams;

      const result = {};

      Object.entries(this.config.params).forEach((o) => {
        const key = o[0];
        const value = o[1];
        const { required, reducer } = value;
        let param = this.pageParams[key];

        if (!param) {
          if (required) {
            throw new Error(`${key}是必要參數。範例：?${key}=xxx`);
          }

          if (value.default) {
            param = value.default;
          }
        }

        if (reducer) {
          param = reducer(param);
        }

        result[key] = param;
      });

      this.params = result;
    },
    startMMS() {
      const { app, websockURL } = this.config;
      this.mms = new MMS(app, websockURL);
      this.mms.OpenMMS(this.onWsOK, this.onDOK, this.onWsState, this.onRcveMsg);
      this.state = '連線websock...';
    },
    async subscribeMMS() {
        this.removeEvent = this.mms.on("registered", async reply => {
             if(reply.ErrMsg == "OK"){
                this.eiInfo.ddn = reply.result.DDN;
                this.webmmsOptions.EiToken = reply.result.EiToken;
                this.webmmsOptions.SToken = reply.result.SToken;
                this.webmmsOptions.UToken = reply.result.UToken;

                this.mmsReady = true;
                this.error = false;

             }else{
                this.mmsReady = false;
                this.error = false;
             }

             let expiredTime = 60 * 60 * 24 * 30 * 12;

            setCookie("yp-EiToken", this.webmmsOptions.EiToken);
            setCookie("yp-SToken", this.webmmsOptions.SToken);

             console.log('regtoCenter: %s', reply.ErrMsg);
             await this.track(this.mms, 'youtube', this.pageParams);
             this.searchText();
        });

        this.mms.on('message', (method, from, data, body) => {
              this.mmsReady = true;
             this.error = false;
             console.log('rcve: from=%s, data=%s', from, JSON.stringify(data));
        });

        this.mms.on('state', msg => {
            console.log('WS error: %s', msg);
            this.mmsReady = false;
            this.error = true;
        });

        this.mms.on('disconnect', msg => {
            this.mmsReady = false;
            this.error = true;
        });

        this.mms.on('error', err => {
             this.mmsReady = false;
            this.error = true;
        });

        this.mms.on('connect_error', err => {
             this.mmsReady = false;
            this.error = true;
        });

        this.mms.on('connect_timeout', err => {
            this.mmsReady = false;
            this.error = true;
        });
      },
    onWsOK(res) {
      this.state = '連線D-center...';
      this.handleErr(res);
    },
    onDOK(res) {
      this.state = '取得Rss資料...';
      this.handleErr(res);
      this.callGetPosts();
    },
    onWsState(res) {
      this.handleErr(res);
    },
    onRcveMsg(res) {
      this.handleErr(res);
    },
    callGetPosts() {
      const { topic, invokeFn } = this.config;
      this.mms.CallMMS('', topic, invokeFn, this.params, null, null, (res) => {
        if (this.handleErr(res)) {
          this.response = res;
          this.loading = false;
        }
      });
    },
    handleErr(res) {
      let content;

      if (Array.isArray(res)) {
        content = res[0].Reply;
      } else {
        content = res;
      }

      const { ErrCode, ErrMsg } = content;

      if (ErrCode && ErrCode !== 0) {
        this.state = ErrMsg;
        return false;
      }

      return true;
    },
  },
};
</script>

<style lang="sass">
.Youtube
  +size(100%, 100%)
  +flex
  &__content
    width: 100%
    overflow: hidden
  &__content__player
    +ab_start
    +size(100%, 100%)
</style>
